var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIstLogotype(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.805,
    height: 24.196,
    viewBox: "0 0 42.805 24.196",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "IST_logotype",
    transform: "translate(-0.005 0.6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(0.005 -0.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M7.838,6.495a1.436,1.436,0,0,1-.769.118c-.8.163-1.7.177-2.5.355a7.2,7.2,0,0,1-1.005.118c-.059.074-.163.089-.3.044a3.362,3.362,0,0,1-.961.192c-.384.148-.916.1-.961.606,0,.089.074.118.074.192a.957.957,0,0,0,.931.473c-.015.163-.148.118-.251.118-.1.044-.177.133-.31.1-.222.724.281.946.931.961a2,2,0,0,1,.8.015,1.954,1.954,0,0,1-.783.163,11.578,11.578,0,0,1-1.788.281c-.148-.089-.163.044-.281-.015a.457.457,0,0,1-.015.31c-.207,0,.015-.31-.192-.177-.148,0-.251.118-.384.148a.82.82,0,0,0-.03.414c.118.089.118.251.207.355a6.032,6.032,0,0,0,1.626.222c0-.015.015-.044.015-.059.207.089.325.015.5.059.621-.074,1.271-.059,1.921-.074.443-.059.961,0,1.4-.074a3.145,3.145,0,0,1,.916-.015c.03-.059.1-.03.177-.015.074-.118.3.03.281-.236.118,0,.133.074.207.118.163.089.177-.059.34.03l-.177.266a.768.768,0,0,1-.414.015,1.355,1.355,0,0,1-.37.089c-1.079.1-2.38.236-3.488.414a23.389,23.389,0,0,0-2.66.429.414.414,0,0,0-.31.355.926.926,0,0,0,.813.754c.03.015.074.015.1.03-.074.384.31.458.148.887-.325.089-.68.118-1.02.177-.251.384.148.591.133.946a2.427,2.427,0,0,1,.828.148,1.831,1.831,0,0,1,.8.015,1.96,1.96,0,0,1,1.094.03,1.533,1.533,0,0,1-.916.192c-.207.1-.473.089-.68.192-.118.665.251,1.094.976,1.035.281-.1.9-.059,1.02.37.03.148.118.251.074.443a1.907,1.907,0,0,1-.591.1,14.353,14.353,0,0,0-2.956.606c-.148.355.133.4.074.695.1.251.37.118.65.222.532-.044,1.123,0,1.67-.015.473.044,1.123-.222,1.463.133a.112.112,0,0,1-.015.059c.044.769.916.443,1.493.562a1.358,1.358,0,0,1,.695-.015c-.133.222-.443.133-.517.488l.547.177c.236.207.532.074.872.222.68-.089,1.759-.207,1.8.695.443.177.65-.059,1.035.015.532.015,1.02-.059,1.567-.03a1.852,1.852,0,0,1,.828-.1c.99-.089,1.951-.222,2.986-.236.222-.03.384-.207.709-.074l-3.946.754a1.886,1.886,0,0,0,.547,1.33c5.277-.946,11.041-.783,16.318-1.848a17.92,17.92,0,0,1,3.1-.5c-.044-.37.1-.857-.163-1.079A52.658,52.658,0,0,1,25.1,21.379a2.319,2.319,0,0,1-1.227.059.5.5,0,0,1,.443-.192c.118-.118.325-.074.488-.118a1.359,1.359,0,0,1,.606-.148c.015-.059.074-.03.118-.03.148-.118.414-.044.547-.163,3.459-.887,6.592-.946,10.036-1.877.03-.281.65-1.212.384-1.448l1.123-.517c.015-.03.044-.03.059-.074.015-.089-.148-.059-.207-.089.03-.118-.1-.133-.192-.163-.059.044-.163,0-.266-.03a.054.054,0,0,1-.015.044,1.231,1.231,0,0,1-.222-.059.407.407,0,0,1-.355.03c-.059.059-.207-.044-.266.015a2.943,2.943,0,0,1-.813.044c-.1.03-.192.1-.355.03a5.984,5.984,0,0,1-.739.059c-.03.089-.163-.015-.222-.015l.163-.207a.365.365,0,0,1,.355-.074c.163,0,.266-.118.473-.044.044-.1.192-.03.281-.059a5.416,5.416,0,0,1,.872-.1c.384-.074.8-.089,1.182-.148.414-.03.754-.148,1.182-.148.163-.133.488,0,.591-.222.074-.414-.458-.695-.8-.532a.133.133,0,0,0-.074-.015c-.177-.059-.281.03-.458-.03-.015,0-.03,0-.03-.015-.074.059-.222-.03-.31,0-.044.089-.207-.03-.3-.03.044-.059.148-.044.207-.074a3.121,3.121,0,0,1,.384-.03.054.054,0,0,1,.015-.044c.547-.044,1.049-.148,1.582-.207.133-.059.34-.015.458-.133.1-.281-.118-.34-.148-.532a5.039,5.039,0,0,0-1.212-.1.372.372,0,0,1-.31,0c-.177-.03-.281.089-.5,0-.325,0-.621.059-.976.044-.163.059-.414.015-.562.1-.015.044-.074.015-.118.015-.31-.1-.606.133-.872-.059A6.214,6.214,0,0,1,36.5,13.87c.37-.03.695-.133,1.064-.148a.961.961,0,0,1,.517-.074c.532-.118,1.138-.118,1.67-.236a3.4,3.4,0,0,1,.665-.074.176.176,0,0,1,.192-.03,2.983,2.983,0,0,1,.65-.133c.251-.1.606-.074.636-.414,0-.059-.044-.074-.044-.133a.649.649,0,0,0-.621-.325c.015-.1.1-.074.177-.074.059-.03.118-.089.207-.074.148-.473-.192-.621-.621-.65a1.221,1.221,0,0,1-.532-.015,1.4,1.4,0,0,1,.517-.118,7.783,7.783,0,0,1,1.2-.192c.089.059.1-.03.192,0a.25.25,0,0,1,0-.207c.148,0-.015.207.133.118.1,0,.163-.074.251-.1a1.008,1.008,0,0,0,.03-.281c-.089-.059-.074-.163-.133-.236a4.277,4.277,0,0,0-1.079-.148.054.054,0,0,1-.015.044c-.133-.059-.222-.015-.34-.044a12.178,12.178,0,0,1-1.286.044c-.3.03-.636,0-.931.059a2.178,2.178,0,0,1-.621,0c-.015.044-.074.015-.118.015-.044.089-.192-.015-.192.163-.074,0-.089-.044-.133-.074-.1-.059-.118.044-.222-.015-.37.044-.769.015-1.138.089a1.268,1.268,0,0,0-.488.089c-.118-.03-.222.044-.3-.074.059-.1.207-.044.31-.044.089-.074.281.015.384-.03a7.928,7.928,0,0,1,1.315-.207c.074-.044.177-.015.281-.015a.629.629,0,0,1,.251-.059c.724-.074,1.6-.163,2.321-.281a10.18,10.18,0,0,0,1.788-.251.289.289,0,0,0,.207-.236.613.613,0,0,0-.547-.5c-.03,0-.044-.015-.074-.015.059-.251-.207-.31-.1-.591.207-.059.458-.074.68-.118.177-.251-.1-.384-.089-.636a1.336,1.336,0,0,1-.547-.1,1.094,1.094,0,0,1-.532-.015A1.337,1.337,0,0,1,40.71,7.5a1,1,0,0,1,.606-.133c.133-.074.325-.059.458-.133.089-.443-.163-.724-.65-.695-.192.074-.591.044-.68-.251-.015-.1-.089-.163-.044-.3a1.187,1.187,0,0,1,.4-.059,10.686,10.686,0,0,0,1.981-.4c.1-.236-.089-.266-.059-.458-.074-.177-.236-.074-.429-.148-.355.03-.754,0-1.123,0-.31-.03-.739.148-.976-.089a.054.054,0,0,1,.015-.044c-.03-.517-.606-.3-.99-.37a.8.8,0,0,1-.458,0c.089-.148.3-.089.34-.325.03-.163-.148-.192-.118-.355a.054.054,0,0,1-.044-.015c.251-.414.177-.872-.281-1.005.207-.222.059-.384.059-.636a.418.418,0,0,0-.414-.222c-.133,0-.207.059-.384-.015-.074-.251-.044-.562-.266-.724C37.488,1,37.3,1.085,37.074.981c-.458.059-1.182.133-1.2-.458-.3-.118-.429.03-.695-.015-.355-.015-.68.044-1.035.03A1.329,1.329,0,0,1,33.6.6c-.665.059-1.3.148-2,.148-.148.03-.251.133-.473.044-.709.03-1.389.148-2.114.163a5.289,5.289,0,0,1-.857.074.5.5,0,0,1,.384-.148,37.016,37.016,0,0,1,5.07-.857A.611.611,0,0,0,33.409-.6c-2.808.5-5.838.532-8.735.887,0-.015.015-.03.015-.059-.148-.739-1.079-.813-1.744-.68a9.126,9.126,0,0,1-1.138.207c-.384.059-.739.163-1.138.207-.074.089-.251,0-.355.03a1.571,1.571,0,0,1-.665.133,3.214,3.214,0,0,1-.769.118c-.695.281-1.537.266-2.2.517A.233.233,0,0,1,16.5.775a1.2,1.2,0,0,1-.532.059,4.865,4.865,0,0,1-.946.133,10.171,10.171,0,0,1-2.365.266c-.118,0-.192.1-.355.03a1.665,1.665,0,0,1-.828.1c-.177.044-.4,0-.591.03-.429.044-.857.074-1.286.1-.443-.1-.695.133-1.109.089a1.97,1.97,0,0,0-.724.133c-.015.044-.074.044-.074.1-.03.133.222.089.31.148-.044.177.163.192.281.251.089-.059.251,0,.4.03,0-.015.015-.044.015-.059.118.03.222.059.325.089a.637.637,0,0,1,.532-.044c.089-.074.31.059.414-.015a4.715,4.715,0,0,1,1.227-.059c.163-.044.281-.148.532-.044a8.86,8.86,0,0,1,1.109-.089c.03-.133.236.03.34.03l.532.192c-.059.133-.236.074-.37.089s-.222.1-.414.015a.616.616,0,0,1-.547.1c-.236,0-.384.192-.709.074-.059.163-.281.044-.414.074a9.2,9.2,0,0,1-1.3.163c-.576.118-1.2.133-1.774.222-.606.044-1.138.236-1.774.236-.251.192-.724-.015-.887.325-.118.606.68,1.049,1.212.8a.942.942,0,0,1,.1.03c.266.089.414-.044.68.044.015,0,.03.015.059.015.1-.089.34.059.458,0,.074-.118.31.059.443.059-.074.089-.222.059-.31.1a3.7,3.7,0,0,1-.591.044c0,.015-.015.044-.015.059-.813.059-1.582.222-2.38.325-.207.1-.517.015-.68.192-.148.414.163.517.222.783a7.178,7.178,0,0,0,1.818.148.544.544,0,0,1,.458,0c.266.03.414-.133.754,0ZM28.265,8.638Z",
    transform: "translate(-0.005 0.6)",
    fill: "#5081a0",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24",
    "data-name": "Rectangle 24",
    width: 5.129,
    height: 1.153,
    transform: "translate(9.73 4.706)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25",
    "data-name": "Rectangle 25",
    width: 5.129,
    height: 1.153,
    transform: "translate(9.73 6.184)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26",
    "data-name": "Rectangle 26",
    width: 3.473,
    height: 1.123,
    transform: "translate(10.484 7.662)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27",
    "data-name": "Rectangle 27",
    width: 3.473,
    height: 1.138,
    transform: "translate(10.484 9.111)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28",
    "data-name": "Rectangle 28",
    width: 3.473,
    height: 1.138,
    transform: "translate(10.484 10.559)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29",
    "data-name": "Rectangle 29",
    width: 3.473,
    height: 1.123,
    transform: "translate(10.484 12.023)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    width: 3.473,
    height: 1.123,
    transform: "translate(10.484 13.471)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31",
    "data-name": "Rectangle 31",
    width: 5.129,
    height: 1.123,
    transform: "translate(9.73 14.919)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32",
    "data-name": "Rectangle 32",
    width: 5.129,
    height: 1.123,
    transform: "translate(9.73 16.338)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_33",
    "data-name": "Rectangle 33",
    width: 10.686,
    height: 1.153,
    transform: "translate(24.806 4.706)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_34",
    "data-name": "Rectangle 34",
    width: 10.701,
    height: 1.153,
    transform: "translate(24.777 6.184)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35",
    "data-name": "Rectangle 35",
    width: 3.459,
    height: 1.123,
    transform: "translate(28.398 7.662)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_36",
    "data-name": "Rectangle 36",
    width: 2.38,
    height: 0.931,
    transform: "translate(33.142 7.662)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_37",
    "data-name": "Rectangle 37",
    width: 2.38,
    height: 0.931,
    transform: "translate(24.762 7.662)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_38",
    "data-name": "Rectangle 38",
    width: 3.459,
    height: 1.138,
    transform: "translate(28.398 9.111)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_39",
    "data-name": "Rectangle 39",
    width: 3.459,
    height: 1.138,
    transform: "translate(28.398 10.559)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_40",
    "data-name": "Rectangle 40",
    width: 3.459,
    height: 1.123,
    transform: "translate(28.398 12.023)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_41",
    "data-name": "Rectangle 41",
    width: 3.459,
    height: 1.123,
    transform: "translate(28.398 13.471)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_42",
    "data-name": "Rectangle 42",
    width: 5.114,
    height: 1.123,
    transform: "translate(27.585 14.919)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_43",
    "data-name": "Rectangle 43",
    width: 5.114,
    height: 1.123,
    transform: "translate(27.585 16.338)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_44",
    "data-name": "Rectangle 44",
    width: 3.06,
    height: 0.961,
    transform: "translate(21.17 7.662)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_45",
    "data-name": "Rectangle 45",
    width: 3.252,
    height: 0.961,
    transform: "translate(16.101 13.574)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(15.849 4.706)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M117.17,36.453H109.1a2.544,2.544,0,0,1,2.261-1.153h5.809Z",
    transform: "translate(-108.819 -35.3)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M115.551,46.453H107.2V45.64a.81.81,0,0,1,.163-.34h8.2v1.153Z",
    transform: "translate(-107.2 -43.822)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M108.9,113.9h8.321a2.647,2.647,0,0,1-2.321,1.153h-5.986V113.9Z",
    transform: "translate(-108.649 -102.283)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M108.9,103.8h8.514v1.005a1.317,1.317,0,0,1-.074.148H108.9Z",
    transform: "translate(-108.649 -93.675)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_46",
    "data-name": "Rectangle 46",
    width: 3.414,
    height: 1.123,
    transform: "translate(0 2.956)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M108.395,76.038h8.026a2.94,2.94,0,0,0-.606-1.138H107.7a2.654,2.654,0,0,0,.695,1.138",
    transform: "translate(-107.626 -69.047)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M115.134,66.238a3.435,3.435,0,0,0-.946-.458h-3.473V65.1H107.3v1.138Z",
    transform: "translate(-107.285 -60.695)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_47",
    "data-name": "Rectangle 47",
    width: 3.473,
    height: 1.138,
    transform: "translate(5.306 8.72)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M122.371,84.374V84.3H114.7a2.224,2.224,0,0,0,.842.384H118.9v.739h3.488V84.374Z",
    transform: "translate(-113.591 -77.058)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIstLogotype);
export default __webpack_public_path__ + "static/media/IST_logotype.ea122314b1f67f12babf424c5bb53b27.svg";
export { ForwardRef as ReactComponent };